import { render, staticRenderFns } from "./ScreenLaudoConsultaGinecologica.vue?vue&type=template&id=66e17ff2&lang=true&"
import script from "./ScreenLaudoConsultaGinecologica.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoConsultaGinecologica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports